import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import * as fromRoot from '../../reducers/index';
import { Observable } from 'rxjs';
import { SEOService } from '@app/core/services/seo.service';

@Component({
  selector: 'app-deleted',
  templateUrl: './deleted.component.html',
  styleUrls: ['./deleted.component.scss']
})
export class DeletedComponent implements OnInit {
  hasToken$: Observable<boolean>;

  constructor(
    private readonly store$: Store<fromRoot.State>,
    private seoService: SEOService,
  ) {
    this.hasToken$ = this.store$.select(fromRoot.getHasToken);
  }

  ngOnInit(): void {
    // Seo
    this.seoService.removeHreflang();
  }

}
